import { Button, Col, Row } from "react-bootstrap";
import { motion } from "motion/react";

const HeadingComp = ({ filterFunc, cats }) => {
  const handleFilter = (cat) => {
    filterFunc(cat);
  };
  return (
    <Row>
      <Col>
        <h1 className="text-center heading-cont">قائمة الطعام</h1>
        <div className="d-flex justify-content-center mt-3 align-items-center">
          <span className="underline"></span>
        </div>

        <div
          className="btns d-flex gap-2 justify-content-center mt-4"
          dir="ltr"
        >
          {cats.map((cat, index) => {
            return (
              <div key={index}>
                <motion.div
                  initial={{ y: -100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: index * 0.2 }}
                >
                  <Button
                    variant="outline-danger"
                    className="px-3 py-2 text-black fw-bold fs-5 text-capitalize"
                    onClick={() => handleFilter(cat)}
                  >
                    {cat}
                  </Button>
                </motion.div>
              </div>
            );
          })}
        </div>
      </Col>
    </Row>
  );
};

export default HeadingComp;
